import React, { useEffect, useState } from "react";
import { Tabs, Tag, Space, Divider } from "antd";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { Table, Spin } from "antd";
import { getDataDoc } from "../../database";
import { Chart } from "react-google-charts";
import { calculare_medii } from "../../utils/calculare_medie";
import { DatePicker } from "antd";
import { Button } from "antd";
import { calculeaza_medie_materie } from "../../utils/calculare_medie";
import { motiveazaAbsente, motiveaza_absenta } from "../../utils/absente";
import { ciclu } from "../../utils";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
function Statistici() {
  const [claseSelected, setClaseSelected] = useState([]);
  const [eleviSelected, setEleviSelected] = useState([]);
  const [materiiTotal, setMateriiTotal] = useState([]);
  const ref = useRef();
  const [materiiAlese, setMateriiAlese] = useState([]);
  const [gradesElevi, setGradesElevi] = useState([]);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [scutiri, setScutiri] = useState({});
  const [loadingMessage, setLoadingMessage] = useState("");
  const [activeTab, setActiveTab] = useState("1"); // Track active tab
  const clase = useSelector((state) => state.clase);
  const user = useSelector((state) => state.user);
  const materii = useSelector((state) => state.materii);
  const profesori = useSelector((state) => state.profesori);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const getNivelFromClasa = (clasa) => {
    return ciclu(clasa);
  };

  const getClassSortOrder = (anClasa) => {
    const order = {
      Pregătitoare: 0,
      I: 1,
      II: 2,
      III: 3,
      IV: 4,
      V: 5,
      VI: 6,
      VII: 7,
      VIII: 8,
      IX: 9,
      X: 10,
      XI: 11,
      XII: 12,
    };
    return order[anClasa] || 999;
  };

  const sortEleviByClass = (elevi) => {
    return elevi.sort((a, b) => {
      const clasaA = clase?.find((c) => c.id === a.class);
      const clasaB = clase?.find((c) => c.id === b.class);

      if (!clasaA || !clasaB) return 0;

      // Sortează mai întâi după an de clasă
      const orderA = getClassSortOrder(clasaA.anClasa);
      const orderB = getClassSortOrder(clasaB.anClasa);

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      // Apoi după identificator (A, B, C, etc.)
      if (clasaA.identificator !== clasaB.identificator) {
        return clasaA.identificator.localeCompare(clasaB.identificator);
      }

      // În final după nume
      return a.nume.localeCompare(b.nume);
    });
  };

  const getAvailableClase = () => {
    const filtered = clase.filter((c) => {
      if (user.type === "admin") return true;
      else if (c.diriginte === user.uid) return true;
      else if (c.diriginte_step === user.uid) return true;
      return false;
    });

    // Sortare identică cu Clase.jsx
    return filtered.sort((a, b) => {
      // Function to get numeric value for sorting
      const getClassOrder = (anClasa) => {
        const grade = anClasa?.toLowerCase();
        switch (grade) {
          case "pregătitoare":
            return 0;
          case "i":
            return 1;
          case "ii":
            return 2;
          case "iii":
            return 3;
          case "iv":
            return 4;
          case "v":
            return 5;
          case "vi":
            return 6;
          case "vii":
            return 7;
          case "viii":
            return 8;
          case "ix":
            return 9;
          case "x":
            return 10;
          case "xi":
            return 11;
          case "xii":
            return 12;
          case "xiii":
            return 13;
          case "anul i":
            return 14;
          case "anul ii":
            return 15;
          case "anul iii":
            return 16;
          case "anul iv":
            return 17;
          case "anul v":
            return 18;
          default:
            return 999; // Unknown grades go to end
        }
      };

      const orderA = getClassOrder(a?.anClasa);
      const orderB = getClassOrder(b?.anClasa);

      // First sort by grade order
      if (orderA !== orderB) {
        return orderA - orderB;
      }

      // If same grade, sort by identifier (A, B, C, etc.)
      const identifierA = a?.identificator || "";
      const identifierB = b?.identificator || "";
      return identifierA.localeCompare(identifierB);
    });
  };

  const selectClaseByNivel = (nivel) => {
    const availableClase = getAvailableClase();
    let claseToSelect = [];

    console.log("Nivel selectat:", nivel);
    console.log("Clase disponibile:", availableClase);

    if (nivel === "toate") {
      claseToSelect = availableClase.map((c) => c.id);
    } else {
      claseToSelect = availableClase
        .filter((c) => {
          const nivelClasa = getNivelFromClasa(c);
          console.log(
            `Clasa ${c.anClasa}${c.identificator} - nivel: ${nivelClasa}, comparat cu: ${nivel}`
          );
          return nivelClasa === nivel;
        })
        .map((c) => c.id);
    }

    console.log("Clase de selectat:", claseToSelect);
    setClaseSelected(claseToSelect);
  };
  const calculate_medie_materie = (noteElev = [], materie) => {
    let medie = calculeaza_medie_materie(
      noteElev,
      materii?.find((ma) => ma.id === materie)
    );
    return medie.medie;
  };
  const fetchData = async () => {
    if (claseSelected.length === 0) {
      setEleviSelected([]);
      setMateriiTotal([]);
      setScutiri({});
      setGradesElevi({});
      return;
    }

    setLoadingMessage("Încărcare date clase în paralel...");

    // Încarcă toate datele claselor în paralel
    const classDataPromises = claseSelected.map((cls) =>
      getDataDoc("claseData", cls)
    );
    const classesData = await Promise.all(classDataPromises);

    let array = [];
    let scutiriElevi = {};
    let note = {};
    let materiiClasa = [];
    let totalElevi = 0;

    // Calculez totalul de elevi și materiile
    classesData.forEach((classData, index) => {
      totalElevi += (classData?.elevi || []).length;
      materiiClasa = [
        ...(classData?.materii || []).map((m) => m.materie),
        ...materiiClasa,
      ];
    });

    setLoadingMessage(`Procesez ${totalElevi} elevi în paralel...`);

    // Creez toate promise-urile pentru elevi în paralel
    const eleviPromises = [];

    classesData.forEach((classData, classIndex) => {
      const cls = claseSelected[classIndex];
      (classData?.elevi || []).forEach((elev) => {
        if (elev.mutat !== true && elev.retras !== true) {
          eleviPromises.push(
            Promise.all([
              getDataDoc("catalog", elev.id),
              getDataDoc("eleviDocumente", elev.id),
              getDataDoc("elevi", elev.id),
            ]).then(([notes, docs, dataElev]) => {
              note[elev.id] = { note: notes?.note };
              scutiriElevi[elev.id] = docs?.docsElev?.filter(
                (doc) => doc.tip === "scutire" || doc.tip === "bilet"
              );

              return {
                nume:
                  elev.numeDeFamilie + " " + elev.initiala + " " + elev.prenume,
                id: elev.id,
                class: cls,
                gen: dataElev.gen,
                grades: notes?.note,
                medieFinala: parseFloat(
                  calculare_medii(
                    notes?.note || [],
                    materii,
                    scutiriElevi[elev.id]
                  )
                ),
                materiiCorigenta: classData.materii.reduce((arr, m) => {
                  if (
                    calculate_medie_materie(notes?.note, m.materie) !== 0 &&
                    calculate_medie_materie(notes?.note, m.materie) < 5
                  )
                    return [...arr, m.materie];
                  return arr;
                }, []),
              };
            })
          );
        }
      });
    });

    // Execut toate promise-urile în paralel cu progres
    const batchSize = 10; // Procesez în batches de 10 pentru feedback
    for (let i = 0; i < eleviPromises.length; i += batchSize) {
      const batch = eleviPromises.slice(i, i + batchSize);
      const batchResults = await Promise.all(batch);
      array.push(...batchResults);

      const progress = Math.min(i + batchSize, eleviPromises.length);
      setLoadingMessage(
        `Procesați ${progress}/${eleviPromises.length} elevi...`
      );
    }

    setLoadingMessage("Finalizez organizarea datelor...");

    setMateriiTotal(
      materiiClasa.filter((item, index) => materiiClasa.indexOf(item) === index)
    );
    setEleviSelected(sortEleviByClass(array));
    setScutiri(scutiriElevi);
    setGradesElevi(note);
  };

  useEffect(() => {
    const loadData = async () => {
      if (claseSelected.length === 0) {
        setLoading(false);
        setLoadingMessage("");
        return;
      }

      setLoading(true);
      setLoadingMessage("Încărcare date...");
      try {
        await fetchData();
      } finally {
        setLoading(false);
        setLoadingMessage("");
      }
    };
    loadData();
  }, [claseSelected]);

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // Sheet pentru fiecare clasa
    claseSelected.forEach((clsId) => {
      const clasa = clase?.find((c) => c.id === clsId);
      const numeClasa = clasa
        ? `${clasa.anClasa}${clasa.identificator}`
        : clsId;
      const eleviiClasei = eleviSelected.filter((elev) => elev.class === clsId);

      // Calculez statistici pentru clasa
      const totalElevi = eleviiClasei?.length;
      const medieClasa =
        eleviiClasei?.length > 0
          ? (
              eleviiClasei.reduce((acc, el) => acc + el.medieFinala, 0) /
              eleviiClasei?.length
            ).toFixed(2)
          : 0;
      const promovati = eleviiClasei.filter((el) => el.medieFinala >= 5).length;
      const nepromovati = eleviiClasei.filter(
        (el) => el.medieFinala < 5
      ).length;

      const totalAbsente = eleviiClasei.reduce((acc, el) => {
        const absenteElev = (gradesElevi[el.id]?.note || [])
          .filter((n) => {
            if (
              startDate !== undefined &&
              endDate !== undefined &&
              !(n.date >= startDate && n.date <= endDate)
            )
              return false;
            return true;
          })
          .filter((n) => n.tip === "absenta").length;
        return acc + absenteElev;
      }, 0);

      const totalAbsenteMotivate = eleviiClasei.reduce((acc, el) => {
        return (
          acc +
          (gradesElevi[el.id]?.note || [])
            .filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            })
            .filter((n) => n.tip === "absenta")
            .filter((nota) => {
              let scutiriElev = scutiri[el.id];
              if (
                (scutiriElev || []).find((scut) =>
                  motiveaza_absenta(nota, scut)
                )
              )
                return true;
              return false;
            }).length
        );
      }, 0);

      // Date pentru Excel
      const dataClasa = [
        [
          "Nume",
          "Medie Finală",
          "Materii Corigență",
          "Absente",
          "Absente Motivate",
          "Absente Nemotivate",
        ],
        ...eleviiClasei.map((elev) => {
          const absenteElev = (gradesElevi[elev.id]?.note || [])
            .filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            })
            .filter((n) => n.tip === "absenta");

          const absenteMotivate = absenteElev.filter((nota) => {
            let scutiriElev = scutiri[elev.id];
            if (
              (scutiriElev || []).find((scut) => motiveaza_absenta(nota, scut))
            )
              return true;
            return false;
          }).length;

          return [
            elev.nume,
            elev.medieFinala.toFixed(2),
            elev.materiiCorigenta
              .map((m) => materii?.find((ma) => ma.id === m)?.numeMaterie)
              .join(", "),
            absenteElev.length,
            absenteMotivate,
            absenteElev.length - absenteMotivate,
          ];
        }),
        [],
        ["STATISTICI CLASA"],
        ["Total Elevi:", totalElevi],
        ["Media Clasei:", medieClasa],
        ["Promovați:", promovati],
        ["Nepromovați:", nepromovati],
        ["Total Absente:", totalAbsente],
        ["Total Absente Motivate:", totalAbsenteMotivate],
        ["Total Absente Nemotivate:", totalAbsente - totalAbsenteMotivate],
      ];

      const ws = XLSX.utils.aoa_to_sheet(dataClasa);
      XLSX.utils.book_append_sheet(wb, ws, numeClasa);
    });

    // Sheet total cu toate clasele
    const totalElevi = eleviSelected.length;
    const medieTotala =
      totalElevi > 0
        ? (
            eleviSelected.reduce((acc, el) => acc + el.medieFinala, 0) /
            totalElevi
          ).toFixed(2)
        : 0;
    const totalPromovati = eleviSelected.filter(
      (el) => el.medieFinala >= 5
    ).length;
    const totalNepromovati = eleviSelected.filter(
      (el) => el.medieFinala < 5
    ).length;

    const totalAbsenteGeneral = eleviSelected.reduce((acc, el) => {
      const absenteElev = (gradesElevi[el.id]?.note || [])
        .filter((n) => {
          if (
            startDate !== undefined &&
            endDate !== undefined &&
            !(n.date >= startDate && n.date <= endDate)
          )
            return false;
          return true;
        })
        .filter((n) => n.tip === "absenta").length;
      return acc + absenteElev;
    }, 0);

    const dataTotala = [
      [
        "Nume",
        "Clasa",
        "Medie Finală",
        "Materii Corigență",
        "Absente",
        "Absente Motivate",
        "Absente Nemotivate",
      ],
      ...eleviSelected.map((elev) => {
        const clasa = clase?.find((c) => c.id === elev.class);
        const numeClasa = clasa
          ? `${clasa.anClasa}${clasa.identificator}`
          : elev.class;

        const absenteElev = (gradesElevi[elev.id]?.note || [])
          .filter((n) => {
            if (
              startDate !== undefined &&
              endDate !== undefined &&
              !(n.date >= startDate && n.date <= endDate)
            )
              return false;
            return true;
          })
          .filter((n) => n.tip === "absenta");

        const absenteMotivate = absenteElev.filter((nota) => {
          let scutiriElev = scutiri[elev.id];
          if ((scutiriElev || []).find((scut) => motiveaza_absenta(nota, scut)))
            return true;
          return false;
        }).length;

        return [
          elev.nume,
          numeClasa,
          elev.medieFinala.toFixed(2),
          elev.materiiCorigenta
            .map((m) => materii?.find((ma) => ma.id === m)?.numeMaterie)
            .join(", "),
          absenteElev.length,
          absenteMotivate,
          absenteElev.length - absenteMotivate,
        ];
      }),
      [],
      ["STATISTICI GENERALE"],
      ["Total Elevi:", totalElevi],
      ["Media Generală:", medieTotala],
      ["Total Promovați:", totalPromovati],
      ["Total Nepromovați:", totalNepromovati],
      ["Total Absente:", totalAbsenteGeneral],
      [],
      ["DISTRIBUTIE PE CLASE"],
      ...claseSelected.map((clsId) => {
        const clasa = clase?.find((c) => c.id === clsId);
        const numeClasa = clasa
          ? `${clasa.anClasa}${clasa.identificator}`
          : clsId;
        const eleviiClasei = eleviSelected.filter(
          (elev) => elev.class === clsId
        );
        const medieClasa =
          eleviiClasei?.length > 0
            ? (
                eleviiClasei.reduce((acc, el) => acc + el.medieFinala, 0) /
                eleviiClasei?.length
              ).toFixed(2)
            : 0;
        return [
          `Clasa ${numeClasa}:`,
          `${eleviiClasei?.length} elevi`,
          `Media: ${medieClasa}`,
        ];
      }),
    ];

    const wsTotal = XLSX.utils.aoa_to_sheet(dataTotala);
    XLSX.utils.book_append_sheet(wb, wsTotal, "Total");

    // Generez si salvez fișierul
    const fileName = `Statistici-clase-${
      new Date().toISOString().split("T")[0]
    }.xlsx`;

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };
  const StatisticiAbsente = () => {
    const columns = [
      {
        title: "Absente",
        dataIndex: "Phone",
        key: "phone",
        responsive: ["xs"],
        render: (e, data) => {
          const name = () => {
            return (
              <a
                onClick={() => {
                  navigate(`/elev/${data.id}`);
                }}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {data.nume}
              </a>
            );
          };
          const clasa = () => {
            return (
              <a
                onClick={() => {
                  navigate(`/elev/${data.id}`);
                }}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {clase?.find((c) => c.id === data.class).anClasa +
                  clase?.find((c) => c.id === data.class).identificator}
              </a>
            );
          };
          const absmot = () => {
            let absente = motiveazaAbsente(
              data.note.filter((n) => {
                if (
                  startDate !== undefined &&
                  endDate !== undefined &&
                  !(n.date >= startDate && n.date <= endDate)
                )
                  return false;
                return true;
              }),
              scutiri[data.id]
            );

            return (
              <p style={{ fontSize: "20", color: "green" }}>
                {absente.absente_motivate?.length}
              </p>
            );
          };
          const absne = () => {
            let absente = motiveazaAbsente(
              data.note.filter((n) => {
                if (
                  startDate !== undefined &&
                  endDate !== undefined &&
                  !(n.date >= startDate && n.date <= endDate)
                )
                  return false;
                return true;
              }),
              scutiri[data.id]
            );

            return (
              <p style={{ fontSize: "20", color: "red" }}>
                {absente.absente_nemotivate?.length}
              </p>
            );
          };
          const abs = () => {
            let absente = motiveazaAbsente(
              data.note.filter((n) => {
                if (
                  startDate !== undefined &&
                  endDate !== undefined &&
                  !(n.date >= startDate && n.date <= endDate)
                )
                  return false;
                return true;
              }),
              scutiri[data.id]
            );
            return (
              <p style={{ fontSize: "20" }}>
                {" "}
                {absente.absente_dupa_motivari?.length}
              </p>
            );
          };

          return (
            <div style={{ textAlign: "center" }}>
              <p>Nume: {name()}</p>
              <p>Clasa: {clasa()}</p>
              <p>Absente Motiv: {absmot()}</p>
              <p>Absente Nemotiv: {absne()}</p>
              <p>Total abs: {abs()}</p>
            </div>
          );
        },
      },
      {
        title: "Nume",
        dataIndex: "nume",
        key: "nume",
        responsive: ["sm"],
        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        },
      },
      {
        title: "Clasa",
        dataIndex: "class",
        key: "class",
        responsive: ["sm"],

        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.class).anClasa +
                clase?.find((c) => c.id === data.class).identificator}
            </a>
          );
        },
      },
      {
        title: "Absente Mot",
        dataIndex: "motivate",
        responsive: ["sm"],
        sorter: (a, b) => {
          let data = a;
          let scutiriElev = scutiri[data.id];

          let cnt1 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_motivate?.length;
          data = b;
          scutiriElev = scutiri[data.id];

          let cnt2 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_motivate?.length;
          return cnt2 - cnt1;
        },
        render: (e, data) => {
          let scutiriElev = scutiri[data.id];
          let cnt = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_motivate?.length;
          scutiriElev = scutiri[data.id];

          return <p style={{ fontSize: "20", color: "green" }}>{cnt}</p>;
        },
      },
      {
        title: "Abs NemMot",
        dataIndex: "nemotivate",
        responsive: ["sm"],
        sorter: (a, b) => {
          let data = a;
          let scutiriElev = scutiri[data.id];

          let cnt1 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_nemotivate?.length;
          data = b;
          scutiriElev = scutiri[data.id];

          let cnt2 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_nemotivate?.length;
          return cnt2 - cnt1;
        },
        render: (e, data) => {
          let scutiriElev = scutiri[data.id];
          let cnt = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_nemotivate?.length;

          return <p style={{ fontSize: "20", color: "red" }}>{cnt}</p>;
        },
      },
      {
        title: "Abs ",
        dataIndex: "abs",
        responsive: ["sm"],
        sorter: (a, b) => {
          let data = a;
          let scutiriElev = scutiri[data.id];

          let cnt1 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_dupa_motivari?.length;
          data = b;
          scutiriElev = scutiri[data.id];

          let cnt2 = motiveazaAbsente(
            data.note.filter((n) => {
              if (
                startDate !== undefined &&
                endDate !== undefined &&
                !(n.date >= startDate && n.date <= endDate)
              )
                return false;
              return true;
            }),
            scutiriElev
          ).absente_dupa_motivari?.length;
          return cnt2 - cnt1;
        },
        render: (e, data) => {
          let cnt =
            (
              (data.note || []).filter((n) => {
                if (
                  startDate !== undefined &&
                  endDate !== undefined &&
                  !(n.date >= startDate && n.date <= endDate)
                )
                  return false;
                return true;
              }) || []
            )?.filter((n) => n.tip === "absenta").length || 0;

          return <p style={{ fontSize: "20" }}>{cnt}</p>;
        },
      },
    ];

    return (
      <>
        <Table
          pagination={false}
          columns={columns}
          dataSource={eleviSelected?.map((el) => {
            return { ...el, note: gradesElevi[el.id]?.note || [] };
          })}
        />
        <h3>
          Total Absente :&nbsp;
          {eleviSelected?.reduce((acc, el) => {
            return (
              acc +
              (gradesElevi[el.id]?.note || [])
                .filter((n) => {
                  if (
                    startDate !== undefined &&
                    endDate !== undefined &&
                    !(n.date >= startDate && n.date <= endDate)
                  )
                    return false;
                  return true;
                })
                ?.filter((n) => n.tip === "absenta").length
            );
          }, 0)}
        </h3>
        <h3 style={{ color: "green" }}>
          Total Absente Motivate: &nbsp;
          {eleviSelected?.reduce((acc, el) => {
            return (
              acc +
              (gradesElevi[el.id]?.note || [])
                .filter((n) => {
                  if (
                    startDate !== undefined &&
                    endDate !== undefined &&
                    !(n.date >= startDate && n.date <= endDate)
                  )
                    return false;
                  return true;
                })
                ?.filter((n) => n.tip === "absenta")
                ?.filter((nota) => {
                  let scutiriElev = scutiri[el.id];
                  if (
                    (scutiriElev || [])?.find((scut) =>
                      motiveaza_absenta(nota, scut)
                    )
                  )
                    return true;
                  return false;
                }).length
            );
          }, 0)}
        </h3>
        <h3 style={{ color: "red" }}>
          Total Absente Nemotivate:&nbsp;
          {eleviSelected?.reduce((acc, el) => {
            return (
              acc +
              (gradesElevi[el.id]?.note || [])
                .filter((n) => {
                  if (
                    startDate !== undefined &&
                    endDate !== undefined &&
                    !(n.date >= startDate && n.date <= endDate)
                  )
                    return false;
                  return true;
                })
                ?.filter((n) => n.tip === "absenta")
                ?.filter((nota) => {
                  let scutiriElev = scutiri[el.id];
                  if (
                    (scutiriElev || [])?.find((scut) =>
                      motiveaza_absenta(nota, scut)
                    )
                  )
                    return false;
                  return true;
                }).length
            );
          }, 0)}
        </h3>
        <br />
        <Chart
          chartType="Bar"
          width="100%"
          options={{ colors: ["red", "green", "blue"] }}
          data={[
            ["Clasa", "Abs Nemotiv", "Abs Motiv", "Abs"],
            ...claseSelected.map((c) => {
              let clasaData = clase?.find((cls) => cls.id === c);

              let nemotivate = (
                eleviSelected.filter((el) => el.class === clasaData.id) || []
              ).reduce((acc, el) => {
                return (
                  acc +
                  (gradesElevi[el.id]?.note || [])
                    .filter((n) => {
                      if (
                        startDate !== undefined &&
                        endDate !== undefined &&
                        !(n.date >= startDate && n.date <= endDate)
                      )
                        return false;
                      return true;
                    })
                    ?.filter((n) => n.tip === "absenta")
                    ?.filter((nota) => {
                      let scutiriElev = scutiri[el.id];
                      if (
                        (scutiriElev || [])?.find((scut) =>
                          motiveaza_absenta(nota, scut)
                        )
                      )
                        return false;
                      return true;
                    }).length
                );
              }, 0);
              let motivate = (
                eleviSelected.filter((el) => el.class === clasaData.id) || []
              ).reduce((acc, el) => {
                return (
                  acc +
                  (gradesElevi[el.id]?.note || [])
                    .filter((n) => {
                      if (
                        startDate !== undefined &&
                        endDate !== undefined &&
                        !(n.date >= startDate && n.date <= endDate)
                      )
                        return false;
                      return true;
                    })
                    ?.filter((n) => n.tip === "absenta")
                    ?.filter((nota) => {
                      let scutiriElev = scutiri[el.id];
                      if (
                        (scutiriElev || [])?.find((scut) =>
                          motiveaza_absenta(nota, scut)
                        )
                      )
                        return true;
                      return false;
                    }).length
                );
              }, 0);
              let total = (
                eleviSelected.filter((el) => el.class === clasaData.id) || []
              ).reduce((acc, el) => {
                return (
                  acc +
                  (gradesElevi[el.id]?.note || [])
                    .filter((n) => {
                      if (
                        startDate !== undefined &&
                        endDate !== undefined &&
                        !(n.date >= startDate && n.date <= endDate)
                      )
                        return false;
                      return true;
                    })
                    ?.filter((n) => n.tip === "absenta")?.length
                );
              }, 0);
              return [
                clasaData?.anClasa + clasaData?.identificator,
                nemotivate,
                motivate,
                total,
              ];
            }),
          ]}
        />
      </>
    );
  };
  const StatisticiNote = () => {
    const columns = [
      {
        title: "Elevi",
        dataIndex: "phone",
        key: "phone",
        responsive: ["xs"],
        render: (e, data) => {
          const name = () => {
            return (
              <a
                onClick={() => {
                  navigate(`/elev/${data.id}`);
                }}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {clase?.find((c) => c.id === data.class).anClasa +
                  clase?.find((c) => c.id === data.class).identificator}
              </a>
            );
          };
          const clasa = () => {
            return (
              <a
                onClick={() => {
                  navigate(`/elev/${data.id}`);
                }}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {clase?.find((c) => c.id === data.class).anClasa +
                  clase?.find((c) => c.id === data.class).identificator}
              </a>
            );
          };
          const medieFinala = () => {
            return data.medieFinala;
          };
          const gen = () => {
            return data.gen;
          };
          const corigente = () => {
            return (
              <>
                {data.materiiCorigenta.map((e) => (
                  <Tag>
                    {
                      materii?.find((m) => {
                        return m.id === e;
                      })?.numeMaterie
                    }
                  </Tag>
                ))}{" "}
              </>
            );
          };
          return (
            <div style={{ textAlign: "center" }}>
              <p>Nume: {name()}</p>
              <p>Clasa: {clasa()}</p>
              <p>Medie: {medieFinala()}</p>

              <p>Corigente: {corigente()}</p>
            </div>
          );
        },
      },
      {
        title: "Nume",
        dataIndex: "nume",
        key: "nume",
        responsive: ["sm"],
        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        },
      },
      {
        title: "Clasa",
        dataIndex: "class",
        key: "class",
        responsive: ["sm"],
        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.class).anClasa +
                clase?.find((c) => c.id === data.class).identificator}
            </a>
          );
        },
      },
      {
        title: "Medie",
        dataIndex: "medieFinala",
        key: "medieFinala",
        responsive: ["sm"],
        sorter: (a, b) => a.medieFinala - b.medieFinala,
      },

      {
        title: "Materii Corigente",
        data: "corigente",
        key: "corigente",
        responsive: ["sm"],
        render: (e, data) => {
          return (
            <>
              {data.materiiCorigenta.map((e) => (
                <Tag>
                  {
                    materii?.find((m) => {
                      return m.id === e;
                    })?.numeMaterie
                  }
                </Tag>
              ))}{" "}
            </>
          );
        },
      },
    ];
    let elevi = eleviSelected.filter((el) => el.medieFinala > 0);
    let colors = ["red", "blue", "yellow", "green", "purple", "brown"];

    return (
      <>
        <Table
          pagination={false}
          columns={columns}
          dataSource={eleviSelected}
        />
        <h3>
          Medie Cumulata:{" "}
          {parseFloat(
            parseFloat(
              elevi.reduce((acc, cur) => acc + parseFloat(cur.medieFinala), 0) /
                (elevi?.length || 1)
            ).toFixed(2)
          )}
        </h3>

        <h3>Corigente</h3>
        <p>
          La o disciplina:{" "}
          {eleviSelected.filter((e) => e.materiiCorigenta?.length === 1).length}
        </p>
        <p>
          La 2 discipline:{" "}
          {eleviSelected.filter((e) => e.materiiCorigenta?.length === 2).length}
        </p>
        <p>
          La 3 discipline:{" "}
          {eleviSelected.filter((e) => e.materiiCorigenta?.length === 3).length}
        </p>
        <p>
          La 4 discipline:{" "}
          {eleviSelected.filter((e) => e.materiiCorigenta?.length === 4).length}
        </p>
        <p>
          La mai mult de 4 discipline:{" "}
          {eleviSelected.filter((e) => e.materiiCorigenta?.length > 4).length}
        </p>
        <h3></h3>

        <Chart
          chartType="PieChart"
          width="100%"
          data={[
            ["Categorie", "Total"],
            [
              "Promovati",
              eleviSelected.filter((el) => el.medieFinala >= 5).length,
            ],
            [
              "Nepromovati",
              eleviSelected.filter((el) => el.medieFinala < 5).length,
            ],
          ]}
        />
        <h2>Distributia Selectiei</h2>

        <Chart
          chartType="BarChart"
          width="100%"
          options={{
            hAxis: { format: "0" },
            colors: [colors[1 % colors.length]],
          }}
          data={[
            ["Medie", "Numar Elevi"],
            [
              "5-5.99",
              eleviSelected.filter(
                (el) => el.medieFinala >= 5.0 && el.medieFinala <= 5.99
              ).length,
            ],
            [
              "6-6.99",
              eleviSelected.filter(
                (el) => el.medieFinala >= 6.0 && el.medieFinala <= 6.99
              ).length,
            ],
            [
              "7-7.99",
              eleviSelected.filter(
                (el) => el.medieFinala >= 7.0 && el.medieFinala <= 7.99
              ).length,
            ],
            [
              "8-8.99",
              eleviSelected.filter(
                (el) => el.medieFinala >= 8.0 && el.medieFinala <= 8.99
              ).length,
            ],
            [
              "9-9.99",
              eleviSelected.filter(
                (el) => el.medieFinala >= 9.0 && el.medieFinala <= 9.99
              ).length,
            ],
            [
              "10",
              eleviSelected.filter(
                (el) => el.medieFinala >= 10 && el.medieFinala <= 10
              ).length,
            ],
          ]}
        />
        <h2>Media Claselor</h2>
        <Chart
          chartType="ColumnChart"
          width="100%"
          data={[
            ["Clasa", "Media Clasei"],
            ...claseSelected.map((cls) => {
              let eleviiClasei = elevi.filter((e) => e.class === cls);
              let textClas =
                clase?.find((c) => c.id === cls).anClasa +
                clase?.find((c) => c.id === cls).identificator;
              return [
                textClas,
                parseFloat(
                  parseFloat(
                    eleviiClasei.reduce(
                      (acc, cur) => acc + cur.medieFinala,
                      0
                    ) / eleviiClasei?.length
                  ).toFixed(2)
                ),
              ];
            }),
          ]}
        />
        <h2>Distributiile notelor pe clase</h2>
        {claseSelected.map((cls, index) => {
          let textClas =
            clase?.find((c) => c.id === cls).anClasa +
            clase?.find((c) => c.id === cls).identificator;
          let eleviiClasei = eleviSelected.filter((e) => e.class === cls);
          return (
            <>
              <Chart
                chartType="BarChart"
                width="100%"
                options={{
                  title: textClas,
                  hAxis: { format: "0" },
                  colors: [colors[index % colors.length]],
                }}
                data={[
                  ["Medie", "Numar Elevi"],
                  [
                    "5-5.99",
                    eleviiClasei.filter(
                      (el) => el.medieFinala >= 5.0 && el.medieFinala <= 5.99
                    ).length,
                  ],
                  [
                    "6-6.99",
                    eleviiClasei.filter(
                      (el) => el.medieFinala >= 6.0 && el.medieFinala <= 6.99
                    ).length,
                  ],
                  [
                    "7-7.99",
                    eleviiClasei.filter(
                      (el) => el.medieFinala >= 7.0 && el.medieFinala <= 7.99
                    ).length,
                  ],
                  [
                    "8-8.99",
                    eleviiClasei.filter(
                      (el) => el.medieFinala >= 8.0 && el.medieFinala <= 8.99
                    ).length,
                  ],
                  [
                    "9-10",
                    eleviiClasei.filter(
                      (el) => el.medieFinala >= 9.0 && el.medieFinala <= 10
                    ).length,
                  ],
                ]}
              />
              <br />
            </>
          );
        })}
      </>
    );
  };
  const StatisticiMaterii = () => {
    const columns = [
      {
        title: "Nume",
        dataIndex: "nume",
        key: "nume",

        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {data.nume}
            </a>
          );
        },
      },
      {
        title: "Clasa",
        dataIndex: "class",
        key: "class",
        responsive: ["sm"],
        onFilter: (value, record) => record.name.indexOf(value) === 0,
        render: (e, data) => {
          return (
            <a
              onClick={() => {
                navigate(`/elev/${data.id}`);
              }}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {clase?.find((c) => c.id === data.class).anClasa +
                clase?.find((c) => c.id === data.class).identificator}
            </a>
          );
        },
      },
      ...materiiAlese.map((m) => {
        return {
          title: materii?.find((a) => a.id === m).numeMaterie,
          dataIndex: m,
          key: m,
          sorter: (a, b) =>
            (a.grades || [])
              .filter((n) => {
                if (
                  startDate !== undefined &&
                  endDate !== undefined &&
                  !(n.date >= startDate && n.date <= endDate)
                )
                  return false;
                return true;
              })
              ?.filter((g) => g.tip === "nota" && g.materieId === m).length -
            (b.grades || [])?.filter(
              (g) => g.tip === "nota" && g.materieId === m
            ).length,
          render: (e, data) => {
            return (
              <div
                onClick={() => {
                  navigate(`/elev/${data.id}`);
                }}
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto auto ",
                }}
              >
                {(data?.grades || [])
                  .filter((n) => {
                    if (
                      startDate !== undefined &&
                      endDate !== undefined &&
                      !(n.date >= startDate && n.date <= endDate)
                    )
                      return false;
                    return true;
                  })
                  ?.filter((g) => g.tip === "nota" && g.materieId === m)
                  .map((g) => (
                    <p>{g.nota}</p>
                  ))}
              </div>
            );
          },
        };
      }),
    ];
    return (
      <>
        <Select
          mode="multiple"
          placeholder="Materii"
          value={materiiAlese}
          onChange={setMateriiAlese}
          style={{
            width: "100%",
          }}
          options={materiiTotal.map((item) => ({
            value: item,
            label: materii?.find((m) => m.id === item)?.numeMaterie,
          }))}
        />
        <Table
          pagination={false}
          columns={columns}
          dataSource={eleviSelected}
        />
      </>
    );
  };

  const StatisticiElevi = () => {
    const exportEleviToExcel = () => {
      const wb = XLSX.utils.book_new();
      
      // Sheet pentru fiecare clasă
      claseSelected.forEach((clsId) => {
        const clasa = clase?.find((c) => c.id === clsId);
        const numeClasa = clasa
          ? `${clasa.anClasa}${clasa.identificator}`
          : clsId;
        const eleviiClasei = eleviSelected.filter((elev) => elev.class === clsId);
        
        // Găsește dirigintele clasei
        const diriginteProf = profesori?.find((pf) => pf.id === clasa?.diriginte);
        const diriginteStepProf = profesori?.find((pf) => pf.id === clasa?.diriginte_step);
        
        let diriginteText = "Diriginte: ";
        if (diriginteProf) {
          diriginteText += `${diriginteProf.numeDeFamilie} ${diriginteProf.prenume}`;
          if (diriginteStepProf) {
            diriginteText += `, ${diriginteStepProf.numeDeFamilie} ${diriginteStepProf.prenume}`;
          }
        } else {
          diriginteText += "Necunoscut";
        }

        // Date pentru Excel - doar nume și prenume
        const dataClasa = [
          ["Nume", "Prenume"],
          ...eleviiClasei.map((elev) => {
            // Extrage nume și prenume din numele complet
            const numeComplet = elev.nume.split(" ");
            const numeFamilie = numeComplet[0] || "";
            const prenume = numeComplet.slice(2).join(" ") || ""; // Skip inițiala
            
            return [numeFamilie, prenume];
          }),
          [],
          [diriginteText],
        ];

        const ws = XLSX.utils.aoa_to_sheet(dataClasa);
        XLSX.utils.book_append_sheet(wb, ws, numeClasa);
      });

      // Generez și salvez fișierul
      const fileName = `Lista-elevi-${
        new Date().toISOString().split("T")[0]
      }.xlsx`;

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      saveAs(blob, fileName);
    };

    const columns = [
      {
        title: "Nume",
        dataIndex: "nume",
        key: "nume",
        render: (e, data) => {
          const numeComplet = data.nume.split(" ");
          const numeFamilie = numeComplet[0] || "";
          return numeFamilie;
        },
      },
      {
        title: "Prenume", 
        dataIndex: "nume",
        key: "prenume",
        render: (e, data) => {
          const numeComplet = data.nume.split(" ");
          const prenume = numeComplet.slice(2).join(" ") || ""; // Skip inițiala
          return prenume;
        },
      },
      {
        title: "Clasa",
        dataIndex: "class",
        key: "class",
        render: (e, data) => {
          const clasa = clase?.find((c) => c.id === data.class);
          return clasa ? `${clasa.anClasa}${clasa.identificator}` : data.class;
        },
      },
    ];

    return (
      <>
        <div style={{ marginBottom: "16px", textAlign: "right" }}>
          <Button
            type="primary"
            onClick={exportEleviToExcel}
            disabled={claseSelected.length === 0}
            style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
          >
            📋 Export Lista Elevi
          </Button>
        </div>
        
        <Table
          pagination={false}
          columns={columns}
          dataSource={eleviSelected}
        />
        
        <div style={{ marginTop: "20px" }}>
          <h3>Informații Diriginți</h3>
          {claseSelected.map((clsId) => {
            const clasa = clase?.find((c) => c.id === clsId);
            const numeClasa = clasa
              ? `${clasa.anClasa}${clasa.identificator}`
              : clsId;
            const eleviiClasei = eleviSelected.filter((elev) => elev.class === clsId);
            
            // Găsește dirigintele clasei pentru afișare
            const diriginteProf = profesori?.find((pf) => pf.id === clasa?.diriginte);
            const diriginteStepProf = profesori?.find((pf) => pf.id === clasa?.diriginte_step);
            
            let diriginteNume = "Necunoscut";
            if (diriginteProf) {
              diriginteNume = `${diriginteProf.numeDeFamilie} ${diriginteProf.prenume}`;
              if (diriginteStepProf) {
                diriginteNume += `, ${diriginteStepProf.numeDeFamilie} ${diriginteStepProf.prenume}`;
              }
            }
            
            return (
              <div key={clsId} style={{ marginBottom: "10px" }}>
                <strong>Clasa {numeClasa}:</strong> {eleviiClasei.length} elevi
                <br />
                <em>Diriginte: {diriginteNume}</em>
              </div>
            );
          })}
        </div>
      </>
    );
  };
  
  const items = [
    {
      key: "1",
      label: `Absente`,
      children: <StatisticiAbsente />,
    },
    {
      key: "3",
      label: `Medie`,
      children: <StatisticiNote />,
    },
    {
      key: "2",
      label: `Materii`,
      children: <StatisticiMaterii />,
    },
    {
      key: "4",
      label: `Elevi`,
      children: <StatisticiElevi />,
    },
  ];
  const handlePrint = () => {
    if (claseSelected.length === 0 || eleviSelected.length === 0) {
      alert('Nu există date pentru export. Te rugăm să selectezi clase și să aștepți încărcarea datelor.');
      return;
    }

    // Determin tipul raportului bazat pe tab-ul activ
    let reportType = 'general';
    let reportTitle = 'Statistici Clase';

    switch(activeTab) {
      case "1":
        reportType = 'absente';
        reportTitle = 'Statistici Absențe';
        break;
      case "3":
        reportType = 'medie';
        reportTitle = 'Statistici Medii';
        break;
      case "2":
        reportType = 'materii';
        reportTitle = 'Statistici Materii';
        break;
      case "4":
        reportType = 'elevi';
        reportTitle = 'Statistici Elevi';
        break;
      default:
        reportType = 'general';
    }

    // Calculez statistici generale
    const totalElevi = eleviSelected.length;
    const medieTotala = totalElevi > 0
      ? (eleviSelected.reduce((acc, el) => acc + el.medieFinala, 0) / totalElevi).toFixed(2)
      : '0.00';

    const totalAbsenteGeneral = eleviSelected.reduce((acc, el) => {
      const absenteElev = (gradesElevi[el.id]?.note || [])
        .filter(n => {
          if (startDate !== undefined && endDate !== undefined && !(n.date >= startDate && n.date <= endDate))
            return false;
          return n.tip === "absenta";
        }).length;
      return acc + absenteElev;
    }, 0);

    const totalAbsenteMotivate = eleviSelected.reduce((acc, el) => {
      const absenteElev = (gradesElevi[el.id]?.note || [])
        .filter(n => {
          if (startDate !== undefined && endDate !== undefined && !(n.date >= startDate && n.date <= endDate))
            return false;
          return n.tip === "absenta";
        });

      const motivate = absenteElev.filter(nota => {
        let scutiriElev = scutiri[el.id];
        return (scutiriElev || []).find(scut => motiveaza_absenta(nota, scut));
      }).length;

      return acc + motivate;
    }, 0);

    const totalAbsenteNemotivate = totalAbsenteGeneral - totalAbsenteMotivate;

    // Pregătesc datele pentru fiecare clasă
    const claseData = claseSelected.map(clsId => {
      const clasa = clase?.find(c => c.id === clsId);
      const numeClasa = clasa ? `${clasa.anClasa}${clasa.identificator}` : clsId;
      const eleviiClasei = eleviSelected.filter(elev => elev.class === clsId);

      const medieClasa = eleviiClasei.length > 0
        ? (eleviiClasei.reduce((acc, el) => acc + el.medieFinala, 0) / eleviiClasei.length).toFixed(2)
        : '0.00';

      const promovati = eleviiClasei.filter(el => el.medieFinala >= 5).length;
      const nepromovati = eleviiClasei.filter(el => el.medieFinala < 5).length;

      // Calculez absențe pentru clasă
      const totalAbsente = eleviiClasei.reduce((acc, el) => {
        const absenteElev = (gradesElevi[el.id]?.note || [])
          .filter(n => {
            if (startDate !== undefined && endDate !== undefined && !(n.date >= startDate && n.date <= endDate))
              return false;
            return n.tip === "absenta";
          });
        return acc + absenteElev.length;
      }, 0);

      const absenteMotivate = eleviiClasei.reduce((acc, el) => {
        const absenteElev = (gradesElevi[el.id]?.note || [])
          .filter(n => {
            if (startDate !== undefined && endDate !== undefined && !(n.date >= startDate && n.date <= endDate))
              return false;
            return n.tip === "absenta";
          });
        const motivate = absenteElev.filter(nota => {
          let scutiriElev = scutiri[el.id];
          return (scutiriElev || []).find(scut => motiveaza_absenta(nota, scut));
        }).length;
        return acc + motivate;
      }, 0);

      const absenteNemotivate = totalAbsente - absenteMotivate;

      // Găsește dirigintele clasei
      const diriginteProf = profesori?.find(pf => pf.id === clasa?.diriginte);
      const diriginteStepProf = profesori?.find(pf => pf.id === clasa?.diriginte_step);
      let diriginteNume = "Necunoscut";
      if (diriginteProf) {
        diriginteNume = `${diriginteProf.numeDeFamilie} ${diriginteProf.prenume}`;
        if (diriginteStepProf) {
          diriginteNume += `, ${diriginteStepProf.numeDeFamilie} ${diriginteStepProf.prenume}`;
        }
      }

      // Pregătesc datele elevilor
      const eleviData = eleviiClasei.map(elev => {
        const absenteElev = (gradesElevi[elev.id]?.note || [])
          .filter(n => {
            if (startDate !== undefined && endDate !== undefined && !(n.date >= startDate && n.date <= endDate))
              return false;
            return n.tip === "absenta";
          });

        const absenteMotivate = absenteElev.filter(nota => {
          let scutiriElev = scutiri[elev.id];
          return (scutiriElev || []).find(scut => motiveaza_absenta(nota, scut));
        }).length;

        return {
          nume: elev.nume,
          medie: elev.medieFinala.toFixed(2),
          absente: absenteElev.length,
          absenteMotivate: absenteMotivate,
          absenteNemotivate: absenteElev.length - absenteMotivate
        };
      });

      return {
        numeClasa,
        diriginte: diriginteNume,
        totalElevi: eleviiClasei.length,
        medieClasa,
        promovati,
        nepromovati,
        totalAbsente,
        absenteMotivate,
        absenteNemotivate,
        elevi: eleviData
      };
    });

    // Pregătesc obiectul final de date
    const printData = {
      reportType: reportType,
      reportTitle: reportTitle,
      logo: process.env.REACT_APP_LOGO,
      appName: process.env.REACT_APP_NAME,
      startDate: startDate,
      endDate: endDate,
      totalElevi,
      totalClase: claseSelected.length,
      medieGenerala: medieTotala,
      totalAbsente: totalAbsenteGeneral,
      totalAbsenteMotivate: totalAbsenteMotivate,
      totalAbsenteNemotivate: totalAbsenteNemotivate,
      clase: claseData
    };

    // Deschid fereastra de print
    const printWindow = window.open('/statistici-print.html', '_blank', 'width=1200,height=800');

    if (printWindow) {
      printWindow.addEventListener('load', () => {
        // Trimite datele către fereastra de print
        printWindow.postMessage({
          type: 'STATISTICI_PRINT_DATA',
          data: printData,
          autoPrint: true
        }, '*');
      });
    } else {
      alert('Pop-up blocat! Te rugăm să permiți pop-up-urile pentru această pagină.');
    }
  };
  return (
    <div ref={ref}>
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <div>
          <h4>Selectare Rapidă pe Nivele:</h4>
          <Space wrap>
            <Button
              type="default"
              onClick={() => {
                console.log("Buton Toate Clasele apăsat");
                selectClaseByNivel("toate");
              }}
              style={{ marginBottom: "8px" }}
              loading={loading}
            >
              🏫 Toate Clasele
            </Button>
            <Button
              type="default"
              onClick={() => {
                console.log("Buton Primar apăsat");
                selectClaseByNivel("primar");
              }}
              style={{ marginBottom: "8px" }}
              loading={loading}
            >
              🎒 Primar (I-IV)
            </Button>
            <Button
              type="default"
              onClick={() => {
                console.log("Buton Gimnaziu apăsat");
                selectClaseByNivel("gimnaziu");
              }}
              style={{ marginBottom: "8px" }}
              loading={loading}
            >
              📚 Gimnaziu (V-VIII)
            </Button>
            <Button
              type="default"
              onClick={() => {
                console.log("Buton Liceu apăsat");
                selectClaseByNivel("liceu");
              }}
              style={{ marginBottom: "8px" }}
              loading={loading}
            >
              🎓 Liceu (IX-XII)
            </Button>
            <Button
              type="default"
              onClick={() => {
                console.log("Buton Postliceala apăsat");
                selectClaseByNivel("postliceala");
              }}
              style={{ marginBottom: "8px" }}
              loading={loading}
            >
              🎯 Postliceala
            </Button>
          </Space>
        </div>

        <div>
          <h4>Sau Selectează Manual:</h4>
          <Select
            mode="multiple"
            placeholder="Selectează clasele pentru statistici"
            value={claseSelected}
            onChange={setClaseSelected}
            style={{ width: "100%" }}
            options={getAvailableClase().map((item) => ({
              value: item.id,
              label: `${item.anClasa}${item.identificator} (${getNivelFromClasa(
                item
              )})`,
            }))}
          />
        </div>

        <div>
          <h4>Perioada (opțional):</h4>
          <DatePicker.RangePicker
            placeholder={["Data început", "Data sfârșit"]}
            style={{ width: "100%" }}
            onChange={(e) => {
              setStartDate(
                (e || [])?.map((d, index) => {
                  d.valueOf();
                  let newDate = d.toDate();
                  if (index === 0) newDate.setHours(0, 0, 0, 0);
                  else newDate.setHours(23, 59, 59, 59);
                  return newDate.getTime();
                })?.[0] || undefined
              );
              setEndDate(
                (e || [])?.map((d, index) => {
                  d.valueOf();
                  let newDate = d.toDate();
                  if (index === 0) newDate.setHours(0, 0, 0, 0);
                  else newDate.setHours(23, 59, 59, 59);
                  return newDate.getTime();
                })?.[1] || undefined
              );
            }}
          />
        </div>

        <div style={{ textAlign: "center" }}>
          <Space>
            <Button
              type="primary"
              onClick={exportToExcel}
              disabled={claseSelected.length === 0}
              style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            >
              📊 Export Excel
            </Button>
            <Button
              onClick={() => handlePrint()}
              disabled={claseSelected.length === 0}
            >
              🖨️ Print
            </Button>
          </Space>
        </div>
      </Space>

      <br />

      {loading && (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            background: "linear-gradient(135deg, #003d82 0%, #0066cc 100%)",
            borderRadius: "15px",
            color: "white",
            margin: "20px 0",
          }}
        >
          <Spin
            size="large"
            style={{
              ".ant-spin-dot-item": { backgroundColor: "white" },
            }}
          />
          <div
            style={{
              marginTop: "20px",
              fontSize: "18px",
              fontWeight: "500",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            {loadingMessage || "Se încarcă datele..."}
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              opacity: 0.9,
            }}
          >
            Vă rugăm să așteptați...
          </div>
        </div>
      )}

      {!loading && claseSelected.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            background: "#f0f2f5",
            borderRadius: "10px",
            margin: "20px 0",
          }}
        >
          <h3 style={{ color: "#666" }}>
            👆 Selectează clasele pentru a vedea statisticile
          </h3>
          <p style={{ color: "#999" }}>
            Folosește filtrele de mai sus pentru a alege nivelul educațional și
            clasele dorite.
          </p>
        </div>
      )}

      {!loading && claseSelected.length > 0 && (
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
        />
      )}
    </div>
  );
}

export default Statistici;
